import React from 'react'
import SupplierContactList from './SupplierContactList'
import SupplierContactsOptions from './options/SupplierContactsOptions'

const SupplierContacts = ({ supplier }) => {
  return (
    <div>
        <h4>Контакти</h4>

        <SupplierContactsOptions 
            supplierId={supplier.id}
        />

        <SupplierContactList />
    </div>
  )
}

export default SupplierContacts